import { Component, computed, inject, input } from '@angular/core';
import { CrntIcon } from '@essent/current-web-angular';
import type { RichTextField } from '@core/jss-proxy';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { FieldService } from '@core/jss-utils';

@Component({
  selector: 'wl-notification',
  standalone: true,
  templateUrl: './notification.component.html',
  styleUrls: [
    './notification.component.ed.scss',
    './notification.component.essent.scss',
  ],
  imports: [CrntIcon, RichTextWrapperComponent],
})
export class NotificationComponent {
  readonly message = input.required<RichTextField>();

  readonly #fieldService = inject(FieldService);

  readonly showMessage = computed(() =>
    this.#fieldService.showTextField(this.message())
  );
}
